import Vue from 'vue'
import Clipboard from 'v-clipboard'
import i18n from './i18n'
import router from './router'
import App from './App'
import { initVerifiedHttpClient } from './verifiedapi'
import {
  NODE_ENV,
  AUTH_ENABLED,
  SIMBA_SERVICE_BASE_URL,
  AUTH_URL,
  OIDC_ENABLED,
  OIDC_ISSUER,
  OIDC_SCOPE,
  OIDC_TOKEN_URL,
  OAUTH_TOKEN_URL,
  OAUTH_AUTH_URL,
  SSO_LOGOUT_URL
} from './config'

Vue.use(Clipboard)
Vue.config.productionTip = false

console.log('[startup] NODE_ENV:', NODE_ENV)
console.group('[startup] runtime config')
console.log('AUTH_ENABLED:', AUTH_ENABLED)
console.log('OIDC_ENABLED:', OIDC_ENABLED)
console.log('OIDC_ISSUER:', OIDC_ISSUER)
console.log('OIDC_SCOPE:', OIDC_SCOPE)
console.log('SIMBA_SERVICE_BASE_URL:', SIMBA_SERVICE_BASE_URL)
console.log('AUTH_URL:', AUTH_URL)
console.log('OIDC_TOKEN_URL:', OIDC_TOKEN_URL)
console.log('OAUTH_TOKEN_URL:', OAUTH_TOKEN_URL)
console.log('OAUTH_AUTH_URL:', OAUTH_AUTH_URL)
console.log('SSO_LOGOUT_URL:', SSO_LOGOUT_URL)
console.groupEnd()

export { AUTH_ENABLED, SIMBA_SERVICE_BASE_URL, AUTH_URL, OIDC_ENABLED }

Vue.prototype.$verifiedAPI = initVerifiedHttpClient(SIMBA_SERVICE_BASE_URL)

const app = {
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<app/>'
}

Object.defineProperty(Vue.prototype, '$locale', {
  get: function () {
    return app.i18n.locale
  },
  set: function (locale) {
    app.i18n.locale = locale
  }
})

/* eslint-disable no-new */
new Vue(app)



// WEBPACK FOOTER //
// ./src/main.js